module.exports = __webpack_public_path__ + "926efcbb98d4f13ba3f50f05e4759f67.png";